export default {
      id: "circle-warning-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#circle-warning",
      toString: function () {
        return this.url;
      }
    }